import React from 'react';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import { isPaid, redirectToCheckout } from './paywall';

const useStyles = makeStyles((theme) => ({
  root: {
    color: '#000',
    textShadow: '1px 1px 0px #ffaa0a',
    textAlign: 'center',
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
  },
  logo: {
    width: '100%',
    maxWidth: 700,
    height: 'auto',
    marginBottom: theme.spacing(2),
  },
  body: {
    color: '#000',
    fontWeight: 600,
    fontSize: '1.15rem',
    lineHeight: 1.55,
    maxWidth: 640,
    margin: '0 auto',
    '& p': {
      margin: theme.spacing(1.5, 0),
    },
  },
  testimonial: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexWrap: 'nowrap',
    gap: theme.spacing(3),
    margin: theme.spacing(5, 'auto'),
    maxWidth: 720,
  },
  testimonialReverse: {
    flexDirection: 'row-reverse',
  },
  testimonialPhoto: {
    width: '50%',
    flex: '0 0 50%',
    height: 'auto',
    borderRadius: 4,
    boxShadow: '0 4px 10px rgba(0,0,0,0.4)',
  },
  testimonialText: {
    flex: '0 0 50%',
    width: '50%',
    color: '#000',
    fontWeight: 600,
  },
  testimonialName: {
    fontSize: '1.6rem',
    lineHeight: 1.1,
    marginBottom: theme.spacing(0.5),
  },
  testimonialLocation: {
    fontSize: '1.3rem',
    marginBottom: theme.spacing(1.5),
  },
  testimonialQuote: {
    fontSize: '1.2rem',
    fontStyle: 'italic',
    lineHeight: 1.4,
    textAlign: 'justify',
  },
  cta: {
    margin: theme.spacing(4, 0, 2),
  },
  ctaButton: {
    fontSize: '2rem',
    padding: theme.spacing(1.5, 5),
    background: 'linear-gradient(0deg, #de3907 1%, #edad24 150%)',
    color: '#fff',
    textShadow: '1px 1px 0 #000',
    '&:hover': {
      background: 'linear-gradient(5deg, #de3907 1%, #edad24 150%)',
    },
  },
}));

function Testimonial({ name, location, quote, photo, alt, reverse }) {
  const classes = useStyles();
  return (
    <Box
      className={
        classes.testimonial + (reverse ? ' ' + classes.testimonialReverse : '')
      }
    >
      <img src={photo} alt={alt} className={classes.testimonialPhoto} />
      <Box className={classes.testimonialText}>
        <div className={classes.testimonialName}>{name}</div>
        <div className={classes.testimonialLocation}>{location}</div>
        <div className={classes.testimonialQuote}>{quote}</div>
      </Box>
    </Box>
  );
}

export default function Landing(props) {
  const classes = useStyles();
  const onPlayNow = () => {
    if (isPaid()) {
      props.callback('next');
    } else {
      redirectToCheckout();
    }
  };

  return (
    <Box className={classes.root}>
      <Box className={classes.body}>
        <p>This isn't just a beer drinking game &mdash; it's a full-on comedy!</p>
        <p>
          You're laughing, reacting, and jumping into wild challenges while
          bold, adult humor keeps the pressure cranked all the way up. Every
          second counts as new categories hit, forcing you to think fast, move
          faster, and keep that drink going.
        </p>
        <p>
          One minute you're cracking up&hellip; the next you're in the hot seat
          or squeezing one!
        </p>
        <p>No breaks. No mercy. Just pure chaos, competition, and nonstop fun.</p>
        <p>From rapid-fire Multiple Choice to unpredictable Acting Out&hellip;</p>
        <p>from brain-twisting Continuations to risky True or False&hellip;</p>
        <p>
          throw in Rock Paper Scissors battles, Drink &amp; Touch dares, Virtual
          Drink Cards, and more&mdash;
        </p>
        <p>
          You never know what's coming next&hellip; and that's exactly the point.
        </p>
        <p>Good luck. You're gonna need it.</p>
      </Box>

      <Testimonial
        name="John F."
        location="Fortworth, Texas"
        quote={'"Taking the day off. Getting my game on! You Buzzed Yet is the bomb!"'}
        photo="./assets/landing/john.png"
        alt="John F."
      />

      <Testimonial
        name="Kerry O."
        location="Chicago, Illinois"
        quote={'"I have more fun playing You Buzzed Yet?, than I do playing with my pussy!"'}
        photo="./assets/landing/kerry.png"
        alt="Kerry O."
        reverse
      />

      <Testimonial
        name="Brian S."
        location="Hollywood, Cal."
        quote={'"The questions and challenges makes the mind boggle!"'}
        photo="./assets/landing/brian.png"
        alt="Brian S."
      />

      <Box className={classes.cta}>
        <Button
          onClick={onPlayNow}
          variant="contained"
          className={classes.ctaButton}
        >
          Play Now &raquo;
        </Button>
      </Box>
    </Box>
  );
}
